import { Button } from "@/components/ui/button";
import { getDeepLink } from "@/lib/routes";
import Icons from "@/components/Icons";
import { useEffect, useState } from "react";
import type { GameData } from "@/interfaces";

const FailedCheckoutPage = () => {
  const [gameData, setGameData] = useState<GameData | null>(null);

  useEffect(() => {
    const storedGameData = sessionStorage.getItem("gameData");
    if (!storedGameData) return;
    try {
      setGameData(JSON.parse(storedGameData));
    } catch {
      sessionStorage.removeItem("gameData");
    }
  }, []);

  const handleTryAgain = () => {
    if (!gameData) return;
    const deepLink = getDeepLink(gameData);
    window.location.href = deepLink;
  };

  return (
    <section className="flex flex-col flex-1 pt-[17px] pb-[21px] px-3 landscape:h-full landscape:justify-between">
      <div className="flex flex-col justify-center items-center text-center w-full flex-1 landscape:flex-1">
        <Icons type="checkoutFailed" size={96} />
        <h1 className="text-[18px] font-medium max-w-40 text-center text-[#423F3B] mb-[14px] landscape:mb-2">
          This Payment Link Is No Longer Valid
        </h1>
        <p className="text-[#A2998B] flex flex-col items-center landscape:mb-2">
          Contact {gameData?.game_name || "the game"} support to get help
        </p>
      </div>
      <div className="landscape:flex-shrink-0 w-full landscape:max-w-sm landscape:mx-auto">
        <Button variant="backToGame" onClick={handleTryAgain} className="w-full">
          Back to {gameData?.game_name || "the game"}
        </Button>
      </div>
    </section>
  );
};

export default FailedCheckoutPage;
